import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslationService } from './core/services/translation.service';
import { MatSelectChange } from '@angular/material/select';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from './features/auth/services/auth.service';
import { SignalrService, PaymentNotification } from './shared/services/signalr.service';
import { SystemHealthService } from './shared/services/system-health.service';
import { AnalyticsService } from './core/services/analytics.service';
import { ErrorMessageService } from "./core/services/error-message.service";
import { AffiliateTrackingService } from './core/services/affiliate-tracking.service';
import { MatDialog } from '@angular/material/dialog';
import { InformationDialogComponent } from 'src/app/shared/components/information-dialog/information-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  // Lấy ngôn ngữ hiện tại từ Service (đã bao gồm logic check localStorage bên trong)
  langSeleted: string = this.translationService.getCurrentLang();

  private subscription = new Subscription();
  showFloating: boolean = false;
  languages: { value: string, valueView: string }[] = [
    { value: 'en', valueView: 'English' },
    { value: 'vi', valueView: 'Tiếng Việt' }
  ];

  constructor(
    private translationService: TranslationService,
    private authService: AuthService,
    private signalrService: SignalrService,
    private router: Router,
    private systemHealth: SystemHealthService,
    private analytics: AnalyticsService,
    private errorMessageService: ErrorMessageService,
    private affiliateTracking: AffiliateTrackingService,
    private matDialog: MatDialog
  ) {
    // Không cần dùng trực tiếp TranslateService ở đây nữa 
    // vì TranslationService đã xử lý setDefaultLang và use trong constructor của nó rồi.
  }

  ngOnInit(): void {
    this.systemHealth.clear();
    
    // Đảm bảo đồng bộ hóa ngôn ngữ ngay khi khởi tạo App
    this.translationService.setLanguage(this.langSeleted);

    // Kiểm tra user ngay khi khởi tạo
    const currentId = this.authService.getCurrentUserId();
    if (currentId) {
      this.analytics.setUserId(currentId);
    }

    // Capture affiliate ref_hash from URL query param and store in cookie (Task 9)
    this.affiliateTracking.captureFromUrl();

    this.checkFloatingVisibility(this.router.url);

    // Track initial page load
    this.analytics.trackPageVisit(this.router.url).subscribe({
      error: (err) => console.debug('Failed to track initial page load:', err)
    });

    // Track all subsequent navigation events
    this.subscription.add(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.analytics.trackPageVisit(event.urlAfterRedirects).subscribe({
            error: (err) => console.debug('Failed to track page visit:', err)
          });
          this.checkFloatingVisibility(event.urlAfterRedirects);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Chức năng chuyển đổi ngôn ngữ chủ động từ người dùng
   */
  async changeLanguage(selectChange: MatSelectChange) {
    const newLang = selectChange.value;
    
    // Gọi hàm setLanguage của Service: 
    // Hàm này sẽ tự động thực hiện: this.translate.use() VÀ localStorage.setItem()
    this.translationService.setLanguage(newLang);
    
    // Cập nhật biến local để hiển thị đúng trên UI (maDt-select)
    this.langSeleted = newLang;
      await this.errorMessageService.setLanguage(newLang);
    
    // Thông báo cho người dùng
    const msg = newLang === 'vi' ? 'Đã đổi sang Tiếng Việt' : 'Language changed to English';
    this.matDialog.open(InformationDialogComponent, {
      width: '400px',
      data: { title: 'Thành công', message: msg, type: 'success', confirmText: 'Đóng' }
    });
  }

  private checkFloatingVisibility(url: string) {
    const allowedRoutes = [
      /^\/$/,         // home
        /^\/product$/  // product list + detail
    ];

    this.showFloating = allowedRoutes.some(route =>
      route.test(url)
    );
  }
}